import { HttpClient, HttpHeaders, JsonpClientBackend } from '@angular/common/http';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { MasterClientModel } from '@core/model/masterClient.model';
import { UserModel } from '@core/model/user.model';
import { EmailValidationModel } from '@core/model/emailValidation.model';
import { LoginModel } from '@core/model/login.model';
import { utiles } from '@utl/environment';
import { LoginTokenModel } from '@core/model/loginToken.model';
import { AddressListModel } from '@core/model/addressList.model';
import { ContactUsModel } from '@core/model/contactUs.model';
import { CommonService } from './common.service';
import { stringify } from '@angular/compiler/src/util';
import { Injectable } from "@angular/core";
import { OrderDetail } from '@core/model/orderDetailClass.model';
import { ColorExpiration } from '@core/model/colorExpiration.model';
import { AddressClassModel } from '@core/model/addressClass.model';
/*Constants */
const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

@Injectable()
export class UserService {

  constructor(public http: HttpClient, private router: Router, private common: CommonService) {
    let data = utiles.getCacheUser();
    if (data !== null && data !== undefined) {
    } else {
      this.common._setLoading(false);
      this.router.navigate(['login']);
    }
  }

  getCustUsers(model: UserModel) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetCustUsers';
    return this.http.post<MasterClientModel[]>(url, JSON.stringify(model.UserId), httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  getUserAccount(model: UserModel) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetUserAccount';
    return this.http.post<UserModel>(url, JSON.stringify(model.UserEmail), httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  async getItemsQtyInCart(model: any) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetItemsQtyInCart';
    let result = await this.http.post<number>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      })).toPromise();
      
    return result;
  }

  getCurrentCartId(model: any) {
    const url = environment.apiURL + 'GetCurrentCartId';
    return this.http.post<number>(url, model, httpOptions)
      .pipe(map(response => {
        return response;
      }));
  }

  getCurrentshoppingCartAddress(model: any) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'getCurrentshoppingCartAddress';
    return this.http.post<any>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  updateShoppingCartSite(model: any) {

    this.common._setLoading(true);
    const url = environment.apiURL + 'updateShoppingCartSite';
    return this.http.post<number>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  validateEmail(model: EmailValidationModel) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'ValidateEmail';
    return this.http.post<any>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  registerUser(model: UserModel) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'RegisterUser';
    return this.http.post<string>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  validateRegisterToken(model: LoginTokenModel) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'ValidateRegisterToken';
    return this.http.post<any>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  activateUser(model: UserModel) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'ActivateUser';
    return this.http.post<any>(url, JSON.stringify(model), httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  loginUser(model: LoginModel) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'Login';
    return this.http.post<any>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  loginAuthenticate(loginData: any) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'EXTECToken/Token';
    return this.http.post<any>(url, loginData, httpOptions).pipe(map(response => {
      this.common._setLoading(false);
      return response;
    }));
  }

  getCurrentVersion() {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetCurrentVersion';
    return this.http.post<any>(url, '', httpOptions).pipe(map(response => {
      this.common._setLoading(false);
      return response;
    }));
  }

  requestPasswordChange(data: any) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'RequestPasswordChange';
    return this.http.post<any>(url, JSON.stringify(data), httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  changePassword(model: LoginModel) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'ChangePassword';
    return this.http.post<any>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }
  
  validAndChangePassword(model: LoginModel) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'ValidAndChangePassword';
    return this.http.post<any>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  validateCurrentPassword(model: LoginModel) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'ValidateCurrentPassword';
    return this.http.post<any>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  resendConfirmationEmail(data: any) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'ChangeRegisterToken';
    return this.http.post<any>(url, JSON.stringify(data), httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  getAddressDeliveryAndHandleList(data: AddressListModel) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'AddressDeliveryAndHandleList';
    return this.http.post<any>(url, JSON.stringify(data), httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  getHandleInventoryInfo() {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetHandleInventoryInfo';
    return this.http.post<any>(url, '', httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

   updateShoppingCartInfo(data: any) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'UpdateShoppingCartInfo';
    return this.http.post<any>(url, JSON.stringify(data), httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  createSalesOrder(ShoppingCartId: number) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'CreateSalesOrder';
    return this.http.post<any>(url, JSON.stringify(ShoppingCartId), httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  getSalesOrder(orderData: any) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetSalesOrders';
    return this.http.post<any>(url, orderData, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  getShoppingCartList(orderData: any) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetShoppingCartList';
    return this.http.post<any>(url, orderData, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  getFavoriteItems(data: any) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetFavoriteItemList';
    return this.http.post<any>(url, data, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  getSalesOrderDetails(data) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetSalesOrderDetail';
    return this.http.post<any>(url, data, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  getShoppingCartLinesSummary(data) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetShoppingCartSummaryLines';
    return this.http.post<any>(url, JSON.stringify(data), httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  updateUserPreferences(data) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'UpdateUserPreferences';
    return this.http.post<any>(url, data, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  associateClientUser(data) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'AssociateClientUser';
    return this.http.post<any>(url, data, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  sendContactUs(data: ContactUsModel) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'SaveContactUs';
    return this.http.post<any>(url, data, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  getCurrencyList(company: string) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'getCurrencyList';
    return this.http.post<any>(url, JSON.stringify(company), httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  AddDiscountCupon(model: any, showLoading: boolean = true) {
    if(showLoading)
      this.common._setLoading(true);
    const url = environment.apiURL + 'AddDiscountCupon';
    return this.http.post<any>(url, model, httpOptions)
      .pipe(map(response => {
        if(showLoading)
          this.common._setLoading(false);
        return response;
      }));
  }

  RemoveDiscountCupon(model: any) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'RemoveDiscountCupon';
    return this.http.post<any>(url, model, httpOptions)
      .pipe(map(response => {
        this.common._setLoading(false);
        return response;
      }));
  }

  ValidateDiscountCupon(model: any) {
    const url = environment.apiURL + 'ValidateDiscountCupon';
    return this.http.post<any>(url, model, httpOptions)
      .pipe(map(response => {
        return response;
      }));
  }

  getSavedCartsQty(model: any) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetSavedCartsQty';
    return this.http.post<number>(url, model, httpOptions)
      .pipe(map(response => {

        this.common._setLoading(false);
        return response;
      }));
  }

  getColorCartByExpiration (model: any) {
    this.common._setLoading(true);
    const url = environment.apiURL + 'GetColorCartByExpiration';

    return this.http.post<ColorExpiration>(url, model, httpOptions)
    .pipe(map(response => {

      this.common._setLoading(false);
      return response;
    }));
  }
}

